import queryString from 'query-string';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App.tsx';
import './lib/initLibs.ts';
import { initSentry } from '@services/sentry';

const email = queryString.parse(location.search).email as string | undefined;

initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      useRefreshTokens
      cacheLocation="localstorage"
      authorizationParams={{
        redirect_uri: window.location.origin,
        scope: import.meta.env.VITE_AUTH0_SCOPE,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        login_hint: email,
        screen_hint: 'signup',
      }}
    >
      <App />
    </Auth0Provider>
  </StrictMode>,
);
